import { render, staticRenderFns } from "./informexls.vue?vue&type=template&id=31b22044&scoped=true"
import script from "./informexls.vue?vue&type=script&lang=js"
export * from "./informexls.vue?vue&type=script&lang=js"
import style0 from "./informexls.vue?vue&type=style&index=0&id=31b22044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b22044",
  null
  
)

export default component.exports